"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = n => ((0, vue_2.pushScopeId)("data-v-3df4d914"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = {
    key: 0,
    class: "banner-container relative grid justify-center mb-4 overflow-hidden"
};
const _hoisted_2 = ["href"];
const _hoisted_3 = ["src", "alt"];
const _hoisted_4 = ["src", "alt"];
const _hoisted_5 = ["aria-label"];
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-chevron-left text-lg" }, null, -1));
const _hoisted_7 = [
    _hoisted_6
];
const _hoisted_8 = ["aria-label"];
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-chevron-right text-lg" }, null, -1));
const _hoisted_10 = [
    _hoisted_9
];
const _hoisted_11 = { class: "banner-dots-container" };
const _hoisted_12 = ["aria-label", "onClick"];
const vue_3 = require("vue");
const shop_1 = require("../common/utils/shop");
const bannerStore_1 = require("../stores/banner/bannerStore");
const vue_router_1 = require("vue-router");
const toastStore_1 = require("../stores/toast/toastStore");
const BannerFile_1 = require("../stores/banner/BannerFile");
const i18n_1 = require("../common/i18n");
exports.default = (0, vue_1.defineComponent)({
    __name: 'Banner',
    props: {
        type: null
    },
    setup(__props) {
        const props = __props;
        const router = (0, vue_router_1.useRouter)();
        const bannerStore = (0, bannerStore_1.useBannerStore)();
        const toastStore = (0, toastStore_1.useToastStore)();
        const targetUrl = (0, vue_3.ref)('');
        const imgUrl = (0, vue_3.ref)('');
        const bannerType = (0, vue_3.ref)('');
        const currentBreakpoint = (0, vue_3.ref)('');
        const bannerFiles = (0, vue_3.ref)([]);
        const currentBannerIndex = (0, vue_3.ref)(0);
        const altText = (0, vue_3.ref)('');
        const bannerInterval = (0, vue_3.ref)(undefined);
        const rotationInterval = 6000;
        const maxVisibleDots = 5;
        const dotStartIndex = (0, vue_3.ref)(0);
        (0, vue_3.onMounted)(() => {
            currentBreakpoint.value = (0, shop_1.getCurrentBreakpoint)();
            bannerType.value = calculateBannerType(props.type);
            window.addEventListener('resize', updateBreakpoint);
        });
        const bannerImgMaxSize = (0, vue_3.computed)(() => {
            if (bannerType.value === BannerFile_1.BannerFileTypeEnum.UNIVERSAL ||
                bannerType.value === BannerFile_1.BannerFileTypeEnum.SEARCH_PAGE_MOBILE ||
                bannerType.value === BannerFile_1.BannerFileTypeEnum.MAIN_PAGE_MOBILE) {
                return 'mobile-banner-size';
            }
            if (bannerType.value === BannerFile_1.BannerFileTypeEnum.SEARCH_PAGE ||
                bannerType.value === BannerFile_1.BannerFileTypeEnum.MAIN_PAGE) {
                return 'desktop-banner-size';
            }
            return '';
        });
        const bannerTransitionName = (0, vue_3.computed)(() => {
            return bannerType.value === BannerFile_1.BannerFileTypeEnum.UNIVERSAL ? 'slide-right' : 'slide';
        });
        const visibleDots = (0, vue_3.computed)(() => {
            // Ha 5 vagy kevesebb banner van, mindegyiket megjelenítjük.
            if (bannerFiles.value.length <= maxVisibleDots) {
                return bannerFiles.value.map((_, index) => index);
            }
            // Egyébként csak 5-öt mutatunk a dotStartIndex-től kezdve.
            const endIndex = Math.min(dotStartIndex.value + maxVisibleDots, bannerFiles.value.length);
            return Array.from({ length: endIndex - dotStartIndex.value }, (_, i) => dotStartIndex.value + i);
        });
        const getBannerFiles = async () => {
            try {
                const params = { type: bannerType.value };
                if (bannerType.value === BannerFile_1.BannerFileTypeEnum.SEARCH_PAGE || bannerType.value === BannerFile_1.BannerFileTypeEnum.SEARCH_PAGE_MOBILE) {
                    params.searchPageType = router.currentRoute.value.name;
                }
                bannerFiles.value = await bannerStore.getActiveBannerFiles(router, params);
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        };
        const calculateBannerType = (type) => {
            if (type === BannerFile_1.BannerFileTypeEnum.MAIN_PAGE || type === BannerFile_1.BannerFileTypeEnum.MAIN_PAGE_MOBILE) {
                return isMobile() ? BannerFile_1.BannerFileTypeEnum.MAIN_PAGE_MOBILE : BannerFile_1.BannerFileTypeEnum.MAIN_PAGE;
            }
            if (type === BannerFile_1.BannerFileTypeEnum.SEARCH_PAGE || type === BannerFile_1.BannerFileTypeEnum.SEARCH_PAGE_MOBILE) {
                return isMobile() ? BannerFile_1.BannerFileTypeEnum.SEARCH_PAGE_MOBILE : BannerFile_1.BannerFileTypeEnum.SEARCH_PAGE;
            }
            if (type === BannerFile_1.BannerFileTypeEnum.UNIVERSAL) {
                return BannerFile_1.BannerFileTypeEnum.UNIVERSAL;
            }
            return BannerFile_1.BannerFileTypeEnum.MAIN_PAGE;
        };
        const isMobile = () => {
            return currentBreakpoint.value === "sm" || currentBreakpoint.value === "md";
        };
        const updateBreakpoint = async () => {
            currentBreakpoint.value = (0, shop_1.getCurrentBreakpoint)();
            bannerType.value = calculateBannerType(bannerType.value);
        };
        const setBannerFiles = async () => {
            resetAndClearInterval();
            currentBannerIndex.value = 0;
            dotStartIndex.value = 0;
            if (bannerFiles.value.length > 0) {
                setBannerFile(0);
                if (bannerFiles.value.length > 1) {
                    startBannerRotation();
                }
            }
        };
        const startBannerRotation = () => {
            resetAndClearInterval();
            if (bannerFiles.value.length > 1) {
                bannerInterval.value = setInterval(() => {
                    const nextIndex = (currentBannerIndex.value + 1) % bannerFiles.value.length;
                    currentBannerIndex.value = nextIndex;
                    updateDotPosition(nextIndex);
                    setBannerFile(nextIndex);
                }, rotationInterval);
            }
        };
        const setBannerFile = async (index) => {
            imgUrl.value = bannerFiles.value[index].fileUrl;
            targetUrl.value = bannerFiles.value[index].targetUrl || '';
            altText.value = `banner-${index + 1}`;
        };
        const updateDotPosition = (targetIndex) => {
            // Ha kevesebb mint 5 banner van, nincs mit csúsztatni.
            if (bannerFiles.value.length <= maxVisibleDots)
                return;
            // Ha a kiválasztott pötty balra esik a látható területtől
            if (targetIndex < dotStartIndex.value) {
                dotStartIndex.value = targetIndex;
            }
            // Ha a kiválasztott pötty jobbra esik a látható területtől
            if (targetIndex >= dotStartIndex.value + maxVisibleDots) {
                dotStartIndex.value = targetIndex - maxVisibleDots + 1;
            }
            // Kezdőpozíció ellenőrzése, hogy mindig érvényes tartományban maradjon.
            dotStartIndex.value = Math.max(0, Math.min(dotStartIndex.value, bannerFiles.value.length - maxVisibleDots));
        };
        const goToBanner = (index) => {
            resetAndClearInterval();
            currentBannerIndex.value = index;
            updateDotPosition(index);
            setBannerFile(index);
            if (bannerFiles.value.length > 1) {
                startBannerRotation();
            }
        };
        const nextBanner = () => {
            const nextIndex = (currentBannerIndex.value + 1) % bannerFiles.value.length;
            goToBanner(nextIndex);
        };
        const previousBanner = () => {
            const prevIndex = currentBannerIndex.value - 1 < 0 ? bannerFiles.value.length - 1 : currentBannerIndex.value - 1;
            goToBanner(prevIndex);
        };
        const resetAndClearInterval = () => {
            clearInterval(bannerInterval.value);
            bannerInterval.value = undefined;
        };
        (0, vue_3.watch)(bannerType, async () => {
            await getBannerFiles();
            setBannerFiles();
        });
        (0, vue_3.onUnmounted)(() => {
            bannerFiles.value = [];
            window.removeEventListener('resize', updateBreakpoint);
            resetAndClearInterval();
        });
        return (_ctx, _cache) => {
            return (bannerFiles.value.length && imgUrl.value)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                    (0, vue_2.createVNode)(vue_2.Transition, {
                        name: (0, vue_2.unref)(bannerTransitionName),
                        mode: "in-out"
                    }, {
                        default: (0, vue_2.withCtx)(() => [
                            ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                key: imgUrl.value,
                                class: "col-start-1 row-start-1"
                            }, [
                                (targetUrl.value)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("a", {
                                        key: 0,
                                        href: targetUrl.value,
                                        target: "_blank"
                                    }, [
                                        (0, vue_2.createElementVNode)("img", {
                                            src: imgUrl.value,
                                            alt: altText.value,
                                            class: (0, vue_2.normalizeClass)([(0, vue_2.unref)(bannerImgMaxSize), "w-full h-auto"])
                                        }, null, 10, _hoisted_3)
                                    ], 8, _hoisted_2))
                                    : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("img", {
                                        key: 1,
                                        src: imgUrl.value,
                                        alt: altText.value,
                                        class: (0, vue_2.normalizeClass)([(0, vue_2.unref)(bannerImgMaxSize), "w-full h-auto"])
                                    }, null, 10, _hoisted_4))
                            ]))
                        ]),
                        _: 1
                    }, 8, ["name"]),
                    (bannerFiles.value.length > 1)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                            key: 0,
                            class: (0, vue_2.normalizeClass)(["banner-arrows-container", (0, vue_2.unref)(bannerImgMaxSize)])
                        }, [
                            (0, vue_2.createElementVNode)("button", {
                                class: "banner-arrow",
                                "aria-label": (0, vue_2.unref)(i18n_1.trans)('previous_banner', 'Previous banner', 'banner'),
                                onClick: previousBanner
                            }, _hoisted_7, 8, _hoisted_5),
                            (0, vue_2.createElementVNode)("button", {
                                class: "banner-arrow",
                                "aria-label": (0, vue_2.unref)(i18n_1.trans)('next_banner', 'Next banner', 'banner'),
                                onClick: nextBanner
                            }, _hoisted_10, 8, _hoisted_8)
                        ], 2))
                        : (0, vue_2.createCommentVNode)("", true),
                    (bannerFiles.value.length > 1)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                            key: 1,
                            class: (0, vue_2.normalizeClass)(["absolute col-start-1 row-start-1 flex justify-center w-full bottom-2", (0, vue_2.unref)(bannerImgMaxSize)])
                        }, [
                            (0, vue_2.createElementVNode)("div", _hoisted_11, [
                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(visibleDots), (index) => {
                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                        key: index,
                                        class: (0, vue_2.normalizeClass)(["banner-dot", currentBannerIndex.value === index ? 'banner-dot-active' : 'banner-dot-inactive']),
                                        "aria-label": (0, vue_2.unref)(i18n_1.trans)('banner_indicator', 'Banner {index}', 'banner', { index: index + 1 }),
                                        onClick: ($event) => (goToBanner(index))
                                    }, null, 10, _hoisted_12));
                                }), 128))
                            ])
                        ], 2))
                        : (0, vue_2.createCommentVNode)("", true)
                ]))
                : (0, vue_2.createCommentVNode)("", true);
        };
    }
});
